<template>
  <div class="image-component" :class="class_list">
    <div class="image-component_image"
         @click="emitClick">
      <img :src="get_image"
           alt="image">
      <div v-show="value" class="image-component_name">{{value}}</div>
    </div>
    <div v-if="!hide_hover_block"
         class="image-component__hover">
      <label title="Delete" @click="$emit('delete')">
        <upload-icon :size="30"/>
        <input type="file" @change="changeValue" accept="*">
      </label>
      <span type="button"
            @click="openModal">
        <edit-icon :size="30"/>
      </span>
      <span title="Delete"
            @click="deleteFile()">
        <trash-icon :size="30"/>
      </span>
    </div>
  </div>
</template>

<script>
import image_mixin from "../../mixins/image_mixin";
import DefaultButton from "../small_components/DefaultButton";
import TrashIcon from "../icons/TrashIcon";
import UploadIcon from "../icons/UploadIcon";
import EditIcon from "../icons/EditIcon";
import {axiosDocuments} from "../../helpers/axios_requests";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DocumentComponent",
  components: {EditIcon, UploadIcon, TrashIcon, DefaultButton},
  mixins: [image_mixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    hide_hover_block: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'getPopupStatus'
    ]),
    get_image() {
      if (!this.value) {
        return this.empty_image
      }
      return this.value
    },
    class_list() {
      return {
        active_modal: this.active_modal,
      }
    }
  },
  data() {
    return {
      active_modal: false,
    }
  },
  methods: {
    ...mapActions([
      'actionSetPopupStatus'
    ]),
    openModal() {
      this.active_modal = true
      this.actionSetPopupStatus(true)
      console.log(this.getPopupStatus);
    },
    emitClick() {
      if (!this.hide_hover_block) return
      this.$emit('click')
    },
    emitInput(value) {
      this.$emit('update:value', value)
    },
    choseItem(item) {
      this.emitInput(item.url)
    },
    changeValue(e) {
      let formData = new FormData();
      formData.append('file', e.target.files[0]);
      if (!e.target.files.length) return
      axiosDocuments.uploadFile(formData)
        .then(r => {
          console.log(r.data)
          e.target.type = 'text'
          e.target.type = 'file'

          this.emitInput(r.data.file_name);
        })
        .finally(() => {
          e.target.type = 'text'
          e.target.type = 'file'
        })
    },
    deleteFile() {
      axiosDocuments.deleteFile({file: this.value})
          .then(r => {
            console.log(r.data)
          })
          .finally(() => {
            this.emitInput();
          })
    }
  },
  watch: {
    'getPopupStatus'(val) {
      if (!val) {
        this.active_modal = false
      }
    }
  }
}
</script>
